<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        <span>{{ "savedCart.changeCompleteOrder" | cxTranslate }}</span>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('close')"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="cx-dialog-info col-md-12">
          <p>
            {{ "savedCart.reqShipDateAllProd" | cxTranslate }} {{
            earliestShipDate }}. {{ "savedCart.proceed" | cxTranslate }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 action-container">
          <button cxAutoFocus class="vs-text-btn" (click)="closeModal('close')">
            {{ "savedCart.cancel" | cxTranslate }}
          </button>
          <button class="vs-primary-btn" (click)="closeModal('success-order')">
            <span> {{ "savedCart.confirm" | cxTranslate }} </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
